import styled from '@emotion/styled'
import { colors, mediaQueriesByDevice } from 'parameters/index'
import { CardBackgroundTheme, CardBorderTheme } from 'components/patterns/themes/styles/backgrounds'

export const Wrapper = styled.div`
	padding: 24px;
	${CardBorderTheme};
	${CardBackgroundTheme};
	box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.08);
	border-radius: 16px;
	height: 120px;
	position: relative;
	overflow: hidden;
	display: flex;
	flex-grow: 1;
	margin-right: 37px;
	width: 100%;

	${mediaQueriesByDevice.tablet} {
		padding: 0;
		flex-grow: 0;
		background: ${colors.white};
		height: 222px;
		border-radius: 8px;
		margin-right: 0;
	}
`

export const Data = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;

	${mediaQueriesByDevice.tablet} {
		flex-direction: column;
		padding-bottom: 10px;
	}
`

export const Purpose = styled.div`
	display: flex;
	align-items: center;
	flex: initial;
	padding-right: 16px;
	position: relative;

	${mediaQueriesByDevice.tablet} {
		width: 100%;
		${CardBackgroundTheme};
		padding: 24px 16px 16px 16px;
		border-radius: 8px 8px 0 0;
		height: 72px;
		overflow: hidden;
	}
`

export const PurposeIcon = styled.div`
	min-width: 72px;
	min-height: 72px;
	border-radius: 16px;
	background: ${colors.white};
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1;

	${mediaQueriesByDevice.tablet} {
		min-width: 48px;
		min-height: 48px;
		border-radius: 8px;
	}
`

export const PurposeInfo = styled.div`
	padding: 0 16px;
`

export const PurposeTitle = styled.div`
	font-weight: bold;
	font-size: 20px;
	line-height: 20px;
`

export const PurposeProduct = styled.div`
	margin-top: 8px;
	font-size: 16px;
	line-height: 16px;
	color: ${colors.primaryDarkGrey1};
`

export const OfferCountBadge = styled.div`
	position: absolute;
	left: 55px;
	top: -5px;
	background: ${colors.secondaryGreen1};
	padding: 1px 7px;
	border-radius: 100%;
	color: ${colors.white};
	z-index: 10;

	${mediaQueriesByDevice.tablet} {
		right: 16px;
		left: unset;
		top: unset;
	}
`

export const BackgroundIcon = styled.div`
	width: 112px;
	height: 112px;
	position: absolute;
	left: -60px;
	top: 0px;
	opacity: 0.2;

	svg {
		width: 100%;
		height: 100%;
	}

	${mediaQueriesByDevice.tablet} {
		width: 80px;
		height: 80px;
		left: -20px;
		top: 5px;
	}
`
